module.exports = __webpack_public_path__ + "img/工作审核.ca8086bb.svg";